import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProfessionalsJSONRes, UserRes } from 'src/app/models';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfessionalService {

  constructor(private http : HttpClient) {}

 /*  LoadProfessionalDocLineByIdProfessional(params : {professionalId:string}):Observable<DoclineGetRes>{
    return this.http.post<DoclineGetRes>(`${environment.url}professionaldocline` , params);
  }

  LoadUserById(professionalId:string):Observable<UserRes>{
    return this.http.get<UserRes>(`${environment.usersUrl}professional?Id=${professionalId}`);
  } */

  LoadUserByEmail(professionalEmail:string):Observable<UserRes>{
    return this.http.get<UserRes>(`${environment.usersService.url}professional?Email=${professionalEmail}`);
  }

  GetProfessionalsJson():Observable<ProfessionalsJSONRes> {
    return this.http.get<ProfessionalsJSONRes>('https://app4.aier.global/platform/api-goingup/doctors?api_key=427116e32a26d646ed4ec9ec6c4158fa0af9f2dbe5ee4d6c116df6c52bf0bdfa');
  }
}
